import { useEffect, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import Pagination from "../../components/common/pagination/Pagination";
import OrderCard from "../../components/common/cards/order-card/OrderCard";


function OrderList() {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getOrders = async (params) => {
    const path = "admin/orders";
    try {
      const response = await getApi({
        path,
        params: { ...params, limit: 20, brand: "attarbashi" },
      });
      console.log(response);
      setData(response.data.result.data);
      setPagination(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (utils) {
      filterDataHandler({
        proccessShipping:
          utils?.ORDER_PROCCESS_SHIPPING_STATUS?.awaitingAccepted?.value,
        paymentStatus: utils?.PAYMENT_STATUS?.done?.value,
        sort: "-paymentDate",
      });
    }
  }, [utils]);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getOrders(allFilter);
  };

  const navigate = useNavigate();

  const getOrderInfo = (id) => {
    navigate(`/order-list/${id}`);
  };
  const editOrder = (id) => {
    navigate(`/order-list/${id}`);
  };

  const handlePrint = () => {
    navigate("/multi-print", { state: { printData: data } });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h3 className="text-gray-800 dark:text-white">لیست سفارشات</h3>
        <button
          onClick={handlePrint}
          className="text-white bg-green-700 hover:bg-green-800 focus:outline-none font-medium rounded-lg text-xs sm:text-sm px-3 sm:px-5 py-2 text-center whitespace-nowrap"
        >
          پرینت این صفحه
        </button>
      </div>{" "}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <div className="px-2 flex flex-col md:flex-row items-center justify-between">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 w-full py-4">
            <div className="w-full sm:w-auto">
              <div className="relative">
                <select
                  onChange={(e) =>
                    filterDataHandler({ page: 1, paymentStatus: e.target.value })
                  }
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
                >
                  <option value={""}>{"همه"}</option>
                  {utils &&
                    utils?.PAYMENT_STATUS_VALUES.map((item) => {
                      if (item.value == utils?.PAYMENT_STATUS?.done?.value) {
                        return (
                          <option selected="selected" value={item.value}>
                            {item.name}
                          </option>
                        );
                      } else {
                        return <option value={item.value}>{item.name}</option>;
                      }
                    })}
                </select>
                <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-full sm:w-auto">
              <div className="relative">
                <select
                  onChange={(e) =>
                    filterDataHandler({ page: 1, proccessShipping: e.target.value })
                  }
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
                >
                  <option value={""}>{"همه"}</option>
                  {utils &&
                    utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES.map((item) => {
                      if (
                        item.value ==
                        utils?.ORDER_PROCCESS_SHIPPING_STATUS?.awaitingAccepted
                          ?.value
                      ) {
                        return (
                          <option selected="selected" value={item.value}>
                            {item.name}
                          </option>
                        );
                      } else {
                        return <option value={item.value}>{item.name}</option>;
                      }
                    })}
                </select>
                <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-full sm:w-auto">
              <div className="relative">
                <select
                  onChange={(e) =>
                    filterDataHandler({ page: 1, hasReferral: e.target.value })
                  }
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
                >
                  <option value={""}>همه</option>
                  <option value={"true"}>با لینک ارجاع</option>
                  <option value={"false"}>بدون لینک ارجاع</option>
                </select>
                <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-full sm:w-auto">
              <div className="relative">
                <select
                  onChange={(e) =>
                    filterDataHandler({ page: 1, sort: e.target.value })
                  }
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
                >
                  <option value={""}>{"بدون مرتب سازی"}</option>
                  <option selected="selected" value={"-paymentDate"}>
                    {"جدیدترین پرداختی"}
                  </option>
                  <option value={"paymentDate"}>{"قدیمی ترین پرداختی"}</option>
                  <option value={"-createdAt"}>{"جدیدترین"}</option>
                  <option value={"createdAt"}>{"قدیمی ترین"}</option>
                </select>
                <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="flex flex-column w-full sm:w-64 sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between">
              <div class="relative w-full">
                <div class="absolute z-[1] inset-y-0 left-0 flex items-center px-3 pointer-events-none">
                  <svg
                    class="w-5 h-5 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  id="table-search"
                  class="block p-2 pe-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full bg-white/50 backdrop-blur-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="جست و جو ..."
                  onChange={(e) =>
                    filterDataHandler({ page: 1, searchText: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-3 items-center justify-between my-2 mt-4 mr-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">
           تعداد نتایج: {" "}
          <span className="font-semibold">{pagination?.totalDocs || 0}</span>
        </p>
      </div>
      <Pagination
        filterDataHandler={filterDataHandler}
        pagination={pagination}
      />
      <div className="mt-4 w-full flex flex-col gap-4">
        {data.length > 0 ? (
          data.map((item, index) => {
            return (
              <OrderCard
                reGetData={() => getOrders({})}
                utils={utils}
                key={index}
                data={item}
                editOrder={editOrder}
                getOrderInfo={getOrderInfo}
              />
            );
          })
        ) : (
          <div className="w-full flex items-center justify-center py-8 text-gray-500 dark:text-white shadow rounded-xl">
            <p>سفارشی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
      <div className="mt-4">
        <Pagination
          filterDataHandler={filterDataHandler}
          pagination={pagination}
        />
      </div>
    </div>
  );
}

export default OrderList;